angular
    .module('vm.helpCenter')
    .controller('SubmitRequestController', SubmitRequestController);

function SubmitRequestController ($api, $element, Notifications, $translate, $timeout, $modal, $scope, $q) {
    const vm = this;
    $scope.vm = vm;

    vm.formData = {
        name: '',
        email: '',
        subjectTag: '',
        subjectTitle: '',
        message: '',
        files: [],
        captchaResponse: null
    };
    vm.selectedSubjectTag = '';

    vm.formSubmitted = false;
    vm.requestForm = null;
    vm.sendingInProcess = false;
    vm.sentRequest = true;

    // Request Sent modal
    vm.requestSentModal = null;
    vm.relatedArticles = [];
    vm.activeArticle= null;

    vm.$onInit = $onInit;
    vm.submitForm = submitForm;
    vm.addFiles = addFiles;
    vm.removeFile = removeFile;
    vm.selectSubjectTag = selectSubjectTag;

    // Request sent modal - functions
    vm.toggleArticle = toggleArticle;
    vm.closeRequest = closeRequest;
    vm.submitRequest = submitRequest;

    ////////////////

    function $onInit() {
        const fileElement = $element[0].querySelector('input[type=file]');
        if (fileElement) {
            fileElement.addEventListener('change', (event) => {
                addFiles(event.target.files);
            })
            ;
        }
    }

    function submitForm() {
        vm.formSubmitted = true;

        if (vm.requestForm.$valid) {
            if (vm.sendingInProcess) {
                return;
            }

            vm.sendingInProcess = true;
            getRelatedArticles();
        }
    }

    function submitRequest() {
        const formData = new FormData();

        if (vm.formData.name && vm.formData.email) {
            formData.append('help_center_contact_us[name]', vm.formData.name);
            formData.append('help_center_contact_us[email]', vm.formData.email);
        }

        formData.append('help_center_contact_us[message]', vm.formData.message);
        formData.append('help_center_contact_us[subjectTag]', vm.formData.subjectTag);
        formData.append('help_center_contact_us[subjectTitle]', vm.formData.subjectTitle);

        if (vm.formData.files.length > 0) {
            vm.formData.files.forEach((file, index) => {
                formData.append(`help_center_contact_us[files_${index}]`, file);
            });
        }

        const options = {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        };

        $api.post('help-center/contact-us', formData, options)
            .then((response) => {
                vm.requestSentModal.hide();

                Notifications.add({
                    type: 'success',
                    text: response.data
                });

                $timeout(function () {
                    redirectToHomePage();
                }, 4000);

            })
            .catch((response) => {
                Notifications.add({
                    type: 'error',
                    text: response.data
                });
            });
    }

    function closeRequest() {
        vm.sentRequest = false;
        vm.requestSentModal.hide();
    }

    function addFiles(files) {
        $timeout(() => {
            if (files.length > 0) {
                for (let i = 0, file; file = files[i]; i++) {
                    i < 6 && vm.formData.files.push(file);
                }
            }
            console.log('SubmitRequestController->addFile->files', vm.formData.files);
        });
    }

    function removeFile(file) {
        const index = vm.formData.files.indexOf(file);
        vm.formData.files.splice(index, 1);
    }

    function selectSubjectTag() {
        $timeout(() => {
            window.location.href = `/help-center/contact-us?subject_tag=${vm.selectedSubjectTag}`;
        }, 100);
    }

    function getRelatedArticles() {
        $api.get(`help-center/search?query=${vm.formData.subjectTitle}`)
            .then(response => {
                vm.relatedArticles = response.data;
                showRequestSentModal();
            })
        ;
    }

    function showRequestSentModal() {
        vm.requestSentModal = $modal({
            templateUrl: 'requestSentModal.html',
            show: true,
            scope: $scope,
            onHide: () => {
                vm.formSubmitted = false;
                vm.sendingInProcess = false;
            }
        });
    }

    function redirectToHomePage() {
        vm.sendingInProcess = false;
        $timeout(() => {
            window.location.href = `/help-center?sent_request=${vm.sentRequest.toString()}`;
        });
    }

    function toggleArticle(article) {
        if (vm.activeArticle === article) {
            vm.activeArticle = null;
        } else {
            vm.activeArticle = article;
        }
    }
}
